export default "__VITE_ASSET__P$FlFMze__"